import Resumo from './resumo';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getListRendaMensalAction,
  getListPatrimonioAction
} from '../../../../store/rendaPatrimonio/actions';

const mapStateToProps = (state) => ({
  rendaPatrimonioReducer: state.rendaPatrimonioReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    getListRendaMensalAction,
    getListPatrimonioAction,
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Resumo);
